var initialState = {
  email: '',
  password: ''
};

export default function loginForm(state = initialState, action) {
  switch (action.type) {
    case 'RESET_LOGIN_FORM':
      return initialState;
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/forms/loginForm.js
 **/